import { shuffleAnimType } from '../../enums/cardTypes';

class AnimationEventsCreator {
  constructor(typeNumber, payload) {
    this.type = `@ANIMATION_${typeNumber}`;
    this.payload = payload;
  }
}

const shuffleCardsCount = 45;

const CardInfoResultDuration = {
  expiredCards: 500,
  newShuffledCards: 6000,
};

const WebShuffleAnimation = [
  new AnimationEventsCreator(1, {
    duration: 2100,
    current: [shuffleAnimType.SHUFFLE_SECOND],
  }),
  new AnimationEventsCreator(2, {
    duration: 2000,
    current: [shuffleAnimType.SHUFFLE_SECOND, shuffleAnimType.CLOSE_SHUFFLE_SECOND],
  }),

  new AnimationEventsCreator(3, {
    duration: 1400,
    current: [shuffleAnimType.SHUFFLE_FIRST],
  }),

  new AnimationEventsCreator(4, {
    duration: 3500,
    current: [shuffleAnimType.SHUFFLE_SECOND],
  }),

  new AnimationEventsCreator(5, {
    duration: 1400,
    current: [shuffleAnimType.SHUFFLE_SECOND, shuffleAnimType.CLOSE_SHUFFLE_SECOND],
  }),

  new AnimationEventsCreator(6, {
    duration: 1400,
    current: [shuffleAnimType.SHUFFLE_FIRST],
  }),
];

const MobileShuffleAnimation = [
  new AnimationEventsCreator(1, {
    duration: 2100,
    current: [shuffleAnimType.CARD_DOWN, shuffleAnimType.SHUFFLE_SECOND],
  }),

  new AnimationEventsCreator(2, {
    duration: 2000,
    current: [
      shuffleAnimType.CARD_DOWN,
      shuffleAnimType.SHUFFLE_SECOND,
      shuffleAnimType.CLOSE_SHUFFLE_SECOND,
    ],
  }),

  new AnimationEventsCreator(3, {
    duration: 1400,
    current: [shuffleAnimType.CARD_DOWN, shuffleAnimType.SHUFFLE_FIRST],
  }),

  new AnimationEventsCreator(4, {
    duration: 3000,
    current: [shuffleAnimType.CARD_DOWN, shuffleAnimType.SHUFFLE_SECOND],
  }),

  new AnimationEventsCreator(5, {
    duration: 1000,
    current: [
      shuffleAnimType.CARD_DOWN,
      shuffleAnimType.SHUFFLE_SECOND,
      shuffleAnimType.CLOSE_SHUFFLE_SECOND,
    ],
  }),

  new AnimationEventsCreator(6, {
    duration: 1000,
    current: [shuffleAnimType.CARD_DOWN, shuffleAnimType.SHUFFLE_FIRST],
  }),

  new AnimationEventsCreator(6, {
    duration: 2000,
    current: [shuffleAnimType.CARDS_WRP],
  }),
];

export { MobileShuffleAnimation, CardInfoResultDuration, WebShuffleAnimation, shuffleCardsCount };
